// gantt-header.component.ts
import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";

let GanttHeaderComponent = {
    selector: "vcGanttHeader",
    templateUrl:
        "/angular/components/planner/gantt-chart/gantt-header.component.html",
    bindings: {
        listCount: "<",
        numAppliedFilters: "=",
        viewMode: "<",
        showCompleted: "<",
        onViewModeChange: "&",
        onShowCompletedChange: "&",
        onRefreshClick: "&",
        onFiltersClick: "&",
    },
    controller: class GanttHeaderController {
        private readonly dialog: DialogUtils;
        public listCount: number = 0;
        public numAppliedFilters: number = 0;
        public viewMode: "days" | "weeks" | "months" | "quarters" = "days";
        public showCompleted: boolean = true;
        public onViewModeChange: (args: { mode: string }) => void;
        public onShowCompletedChange: () => void;
        public onRefreshClick: () => void;
        public onFiltersClick: () => void;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.listCount = this.listCount || 0;
            this.numAppliedFilters = this.numAppliedFilters || 0;
            this.viewMode = this.viewMode || "days";
            this.showCompleted =
                this.showCompleted !== undefined ? this.showCompleted : true;
        }

        public handleViewModeChange(
            mode: "days" | "weeks" | "months" | "quarters"
        ): void {
            if (this.onViewModeChange) {
                this.onViewModeChange({ mode });
            }
        }

        public handleShowCompletedChange(): void {
            if (this.onShowCompletedChange) {
                this.onShowCompletedChange();
            }
        }

        public handleRefreshClick(): void {
            if (this.onRefreshClick) {
                this.onRefreshClick();
            }
        }

        public handleFiltersClick(): void {
            if (this.onFiltersClick) {
                this.onFiltersClick();
            }
        }

        openInfoDialog(ev: any) {
            this.dialog.show({
                component: "vc-gantt-chart-info",
                locals: {},
                ariaLabel: "Info",
            });
        }
    },
};

angular
    .module("planner")
    .component(GanttHeaderComponent.selector, GanttHeaderComponent);
